import { AnyPgColumn, index, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getId,
  getIdReference,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

const getTokenCommonFields = () => ({
  id: getId(),
  createdAt: getTimestampWithTimezone().notNull().defaultNow(),
  deletedAt: getTimestampWithTimezone(), // Soft delete for audit trail
  expiresAt: getTimestampWithTimezone().notNull(),
  // Track IP/UA for each token rotation (not just initial login)
  ipAddress: text().notNull(),
  userAgent: text().notNull(),
})

export const otpTokens = pgTable(
  'otp_tokens',
  {
    ...getTokenCommonFields(),
    email: text().notNull(),
    // SHA-256 hash of OTP + pepper + email (prevents rainbow table attacks)
    tokenHash: text().notNull(),
    // Hidden token for additional security layer
    hiddenTokenHash: text().notNull(), // SHA-256 hashed hidden token
    usedAt: getTimestampWithTimezone(), // Track when token was used
  },
  (table) => [index('otp_tokens_email_idx').on(table.email)],
)

// How a session was originally created. Carried forward across rotations so
// you can answer "where did this session come from?" any time.
export const refreshTokenSourceEnum = pgEnum('refresh_token_source', [
  'otp',
  'google',
  'magic_link',
])

// Refresh tokens table
export const refreshTokens = pgTable(
  'refresh_tokens',
  {
    ...getTokenCommonFields(),
    // SHA-256 hash of the refresh token for secure storage
    tokenHash: text().notNull().unique(),
    userId: getIdReference(() => users.id),
    source: refreshTokenSourceEnum().notNull(),
    // Token chain tracking (self-referencing foreign keys)
    previousTokenId: getNullableIdReference(
      (): AnyPgColumn => refreshTokens.id,
    ),
    initialTokenId: getNullableIdReference((): AnyPgColumn => refreshTokens.id),
  },
  (table) => [index('refresh_tokens_user_id_idx').on(table.userId)],
)
